import clsx from 'classnames';
import copy from 'copy-to-clipboard';
import React, { useState } from 'react';
import copiedIcon from '../../assets/icons/copied_icon.svg';
import copyIcon from '../../assets/icons/copy_icon.svg';
import './index.scss';

export const Copy = ({ content, timeout = 2000, className }) => {
  const [isCopied, setIsCopied] = useState(false);

  return (
    <span className={clsx('copy-icon', className)}>
      <img
        title="Copy"
        alt="copy icon"
        src={isCopied ? copiedIcon : copyIcon}
        onClick={() => {
          copy(content);
          setIsCopied(true);
          setTimeout(() => {
            setIsCopied(false);
          }, timeout);
        }}
      />
    </span>
  );
};
